import React, { SyntheticEvent } from 'react';

import * as S from './styles';

export interface IResourceDropdown {
  items: string[];
  onItemSelect: (x: number) => void;
  activeIndex: number;
  id: string;
  label: string;
  name: string;
}
export const ResourceDropdown: React.FC<IResourceDropdown> = ({
  items,
  onItemSelect,
  activeIndex,
  id,
  label,
  name,
}: IResourceDropdown) => {
  const options = items.map((item, i) => {
    return {
      id: item,
      value: `${i}`,
      text: item,
    };
  });

  const handleChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    const val = +target.value;
    onItemSelect(val);
  };

  return (
    <div data-testid="resourceDropdown">
      <S.Dropdown
        items={options}
        id={id}
        label={label}
        name={name}
        onChange={handleChange}
        value={`${activeIndex}`}
      />
    </div>
  );
};

export default ResourceDropdown;
